import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { isBrowserSupported } from "./index.js";
import {
  Button,
  PopupDialog,
  PopupDialogTitle,
} from "~/components/design-system/index.js";
import { logActionToDatadog } from "~/tracing.js";

export function SupportedBrowserChecker(_props: {}) {
  const userAgent = navigator.userAgent;
  const browserSupportStatus = isBrowserSupported(userAgent);
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (browserSupportStatus.outcome === "failed") {
      setModalOpen(true);
      logActionToDatadog("unsupported_browser_detected", {
        browserSupportStatus,
      });
    }
  }, [browserSupportStatus.outcome]);

  return (
    browserSupportStatus.outcome === "failed" && (
      <PopupDialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <PopupDialogTitle
          titleText={t("components.supportedBrowserChecker.modalTitle")}
          closeDialog={() => setModalOpen(false)}
        ></PopupDialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
          }}
        >
          {browserSupportStatus.reason === "unable-to-detect-browser"
            ? t("components.supportedBrowserChecker.unableToDetectBrowser")
            : browserSupportStatus.reason === "unsupported-browser"
              ? t("components.supportedBrowserChecker.unsupportedBrowser", {
                  browserName:
                    browserSupportStatus.details.browserName ??
                    "Unknown Browser",
                })
              : browserSupportStatus.reason === "outdated-browser"
                ? t("components.supportedBrowserChecker.outdateBrowser", {
                    browserName: browserSupportStatus.details.browserName,
                    browserVersion: browserSupportStatus.details.browserVersion,
                    minimumSupportedVersion:
                      browserSupportStatus.details.minimumSupportedVersion.replace(
                        ">=",
                        "greater than or equal to ",
                      ),
                  })
                : t("components.supportedBrowserChecker.fallbackMessage")}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              color="info"
              variant="contained"
              label={"Close"}
              onClick={() => {
                setModalOpen(false);
              }}
            />
          </Box>
        </Box>
      </PopupDialog>
    )
  );
}
